import { Main } from "@shared/models/Main.model";

export class Role {}

export class RolePermission extends Main {
  id: number = -1;
  name: string = '';
  guard_name: string = '';
}
